import { useSelector } from '@/api/state';
import PurchaseOrderDocumentComponent, {
  PurchaseOrderDocumentSupplier,
} from '@payaca/components/purchaseOrderDocument/PurchaseOrderDocument';
import { getDocumentSenderContextFromAccount } from '@payaca/helpers/documentSenderContextHelper';
import { DocumentSenderContext } from '@payaca/types/accountBrandTypes';
import { NullishAddress } from '@payaca/types/locationTypes';
import { HydratedPurchaseOrder } from '@payaca/types/materialsListTypes';
import { FunctionComponent, type JSX } from 'react';

type Props = {
  purchaseOrder: Omit<HydratedPurchaseOrder, 'supplier'> & {
    supplier: PurchaseOrderDocumentSupplier;
    dueEndAt?: Date;
  };
  project?: {
    reference?: string;
  };
  documentSenderContext?: DocumentSenderContext;
  address?: NullishAddress;
};

const PurchaseOrderDocument: FunctionComponent<Props> = ({
  purchaseOrder,
  project,
  documentSenderContext,
  address,
}: Props): JSX.Element | null => {
  const account = useSelector(
    (state: any) => state.users.myProfile.accounts[0]
  );

  const orderType = purchaseOrder?.metadata?.orderType;
  const fulfillmentDateType = purchaseOrder?.metadata?.fulfillmentDateType;

  if (!purchaseOrder) return null;

  return (
    <PurchaseOrderDocumentComponent
      project={project}
      documentSenderContext={
        documentSenderContext || getDocumentSenderContextFromAccount(account)
      }
      purchaseOrder={purchaseOrder}
      supplier={purchaseOrder.supplier}
      materialPurchaseRecords={purchaseOrder.materialPurchaseRecords}
      materialPurchaseIntents={purchaseOrder.materialPurchaseIntents}
      address={address}
      orderFulfillmentType={
        orderType && fulfillmentDateType
          ? `${orderType}-${fulfillmentDateType}`
          : undefined
      }
    />
  );
};

export default PurchaseOrderDocument;
